var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWantMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7429 17.4576C29.2 17.0701 28.9534 16.3232 28.3555 16.2839L25.3331 16.0852C25.0766 16.0684 24.8526 15.9054 24.7575 15.6665L23.6169 12.8012C23.394 12.2411 22.6011 12.2411 22.3781 12.8012L21.2376 15.6666C21.1425 15.9055 20.9185 16.0684 20.662 16.0852L17.6433 16.2839C17.0456 16.3233 16.799 17.0696 17.2556 17.4573L19.5807 19.4316C19.7749 19.5965 19.8581 19.8575 19.7953 20.1044L19.0327 23.0976C18.8839 23.6818 19.5253 24.1478 20.0349 23.8257L22.6413 22.1782C22.8589 22.0407 23.1362 22.0407 23.3537 22.1782L25.9602 23.8257C26.4698 24.1478 27.1112 23.6818 26.9624 23.0976L26.1999 20.1047C26.137 19.8577 26.2204 19.5964 26.4148 19.4316L28.7429 17.4576Z",
    fill: "#9756DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35938 9.33177C5.35938 5.84777 8.18371 3.02344 11.6677 3.02344C15.1517 3.02344 17.976 5.84777 17.976 9.33177C17.976 12.8158 15.1517 15.6401 11.6677 15.6401C8.18371 15.6401 5.35938 12.8158 5.35938 9.33177Z",
    fill: "#9756DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.35938 27.9984C1.35938 22.3053 5.97457 17.6901 11.6677 17.6901C12.2134 17.6901 12.7492 17.7325 13.272 17.8142C13.3846 18.0439 13.542 18.2527 13.74 18.426L17.0664 20.6651L16.3997 24.6651C16.2067 25.446 16.3997 26.1978 17.1277 26.7428C17.9142 27.3317 19.0722 27.0956 19.7331 26.6651L21.7131 25.675C21.8851 26.4217 21.976 27.1995 21.976 27.9984C21.976 28.5369 21.5395 28.9734 21.001 28.9734H2.33438C1.7959 28.9734 1.35938 28.5369 1.35938 27.9984Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantMore);
export default __webpack_public_path__ + "static/media/want-more.9b88ea8ae82c422a7d12214e1d4fb0fa.svg";
export { ForwardRef as ReactComponent };